export enum EnumCatalogNames {
    GeofenceCategories = "GeofenceCategories",
    GeofenceTypes = "GeofenceTypes"
}